// extracted by mini-css-extract-plugin
export default {"container":"Status_container__Gkc51","text":"Status_text__ES3B0"};